import type { VAxios } from '../../define/axios/Axios';
import { QueryInboxMessageRes, OverviewRes } from '../../entities/mc/index.entities';

export const createApi = (defHttp: VAxios) => ({
  // 读取站内信
  queryInboxMessage: (params: { appCode: string; offset?: number; size: number }) => {
    return defHttp.get<QueryInboxMessageRes[]>({ url: `/mc/messages`, params });
  },

  // 修改站内信为已读
  readMessage: (params: { appCode: string; messageIds: string[] }) => {
    return defHttp.put({ url: `/mc/messages/read`, params });
  },

  // 全部已读
  readAll: (params: { appCode: string }) => {
    return defHttp.put({ url: `/mc/messages/read-all`, params });
  },

  // 站内信未读数量
  unreadMessageNum: (params: { appCode: string }) => {
    return defHttp.get<number>(
      { url: `/mc/messages/unread`, params },
      {
        preventErrorHandle: true,
      },
    );
  },

  overview: (params: { appCode: string }) => {
    return defHttp.get<OverviewRes[]>({ url: `/mc/messages/overview`, params });
  },

  // 弹窗通知
  queryNotifyMessage: (params: { appCode: string }) => {
    return defHttp.get<
      {
        content: string;
        id: number;
        meta: string;
        metaJson: Record<string, unknown>;
        time: string;
      }[]
    >({ url: `/mc/messages/notifications`, params });
  },
});
